module.exports = __webpack_public_path__ + "img/logo_icon.77a2eac2.png";